<div>
    <div class="login-component fs-6 px-3 fw-semibold">
      <span style="color: #2d9de0"> {{greeting}}, <span style="color: black"> {{name}}!</span></span>
    </div>
</div>
